import { store } from "./store";

/** user-defined symbolic name for a PLC address, e.g. I0.0 -> START */
export function tagName(addr: string): string {
  return store.project.tags?.[addr] ?? "";
}

/** "START — I0.0" when named, otherwise "I0.0" */
export function tagLabel(addr: string): string {
  const n = tagName(addr);
  return n ? `${n} — ${addr}` : addr;
}

/** short form for ladder cells: name on top line, address below */
export function tagShort(addr: string): string {
  return tagName(addr) || addr;
}
